import React from "react";
import Container from "./styled";

var number = 1;

export default class ChangeTextTabs extends React.Component {
  constructor(props) {
    super(props);
    this.state = { key: 1 };
  }

  handleSelect(key, textsCategory) {
    this.props.toggleTexts(textsCategory);
    this.setState({ key });
    number = key;
  }

  render() {
    return (
      <Container activeKey={this.state.key}>
        <button
          eventKey={1}
          title="Cobertura"
          onClick={() => this.handleSelect(1, "cobertura")}
          active={number}
          className={number == 1 && "active"}
        >
          <p>Cobertura</p>
        </button>
        <button
          eventKey={2}
          title="Descuentos"
          onClick={() => this.handleSelect(2, "descuentos")}
          active={number}
          className={number == 2 && "active"}
        >
          <p>Descuentos</p>
        </button>
      </Container>
    );
  }
}
